import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent, ViispTicketResponse } from '@ridango/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { NotificationFacade } from '@ridango/components';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'rwidget-login-viisp-form',
    templateUrl: './login-viisp-form.component.html'
})
export class LoginViispFormComponent extends BaseComponent implements OnInit, OnDestroy {
    isNativePlatform = Capacitor.isNativePlatform();
    ticketResponse: ViispTicketResponse = null;
    ticketError = false;

    constructor(
        private client: HttpClient,
        @Inject('ENV') private env,
        private translate: TranslateService,
        private notifications: NotificationFacade
    ) {
        super();
    }

    ngOnInit(): void {
        this.notifications.removeAll();
        const url = `${this.env.API_GATEWAY_URL}/identity/v1/viisp/auth/ticket`;
        const returnUrl = this.isNativePlatform
            ? `${this.env.LOGIN_RETURN_URL}${this.translate.currentLang}/viisp`
            : `${this.env.PAYMENT_RETURN_URL}${this.translate.currentLang}/viisp`;
        this.client
            .post<ViispTicketResponse>(url, {
                returnUrl: returnUrl
            })
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (response) => {
                    this.ticketResponse = response;
                },
                () => {
                    this.ticketError = true;
                    this.notifications.error(this.translate.instant('VIISP_TICKET_LOAD_FAILED'));
                }
            );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
